import React from "react";
import { Link } from "react-router-dom";

import { ArrowRightIcon } from "./icons";

/**
 * One sub-topic on a category page: title, optional one-line description, then
 * its articles separated by hairlines (not gaps), each with an arrow that
 * nudges right on hover.
 */
const TopicCard = ({ title, description, articles, currentId }) => (
  <section className="hc-topic">
    {title ? <h2 className="hc-topic__head">{title}</h2> : null}
    {description ? <p className="hc-topic__sub">{description}</p> : null}
    <ul className="hc-arts">
      {articles.map(article => (
        <li key={article.id}>
          <Link
            to={`/${article.id}`}
            className={`hc-art${article.id === currentId ? " hc-art--open" : ""}`}
            aria-current={article.id === currentId ? "page" : undefined}
          >
            <span className="hc-art__title">{article.title}</span>
            <span className="hc-art__arrow">
              <ArrowRightIcon />
            </span>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

export default TopicCard;
